import axios from 'axios';
import BASE_URL from '../config/baseUrl';

const API_URL = `${BASE_URL}/categories`;

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const categoryService = {
  // Get all categories (public)
  getAllCategories: async () => {
    const response = await axios.get(`${API_URL}/public`);
    return response.data;
  },

  // Get category by ID (public)
  getCategoryById: async (id) => {
    const response = await axios.get(`${API_URL}/public/${id}`);
    return response.data;
  },

  // Get all categories for admin (authenticated)
  getAdminCategories: async () => {
    const response = await axios.get(API_URL, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  // Create category (authenticated)
  createCategory: async (categoryData) => {
    const response = await axios.post(API_URL, categoryData, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  // Update category (authenticated)
  updateCategory: async (id, categoryData) => {
    const response = await axios.put(`${API_URL}/${id}`, categoryData, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  // Delete category (authenticated)
  deleteCategory: async (id) => {
    const response = await axios.delete(`${API_URL}/${id}`, {
      headers: getAuthHeader()
    });
    return response.data;
  }
};

export default categoryService;
